<script lang="ts" setup>
import { useCartStore } from "~/stores/cartStore";
import { useMainStore } from "~/stores/main";
import { usePriceFormatter } from "~/utils/priceFormatter";

const mainStore = useMainStore();
const cartStore = useCartStore();
const { cartData } = storeToRefs(cartStore);
const { t } = useI18n();

// -----------------------
// reactive properties
// -----------------------
const { data: shippingMethodsRef } = await useApiFetch("shipping-methods");

const itemsPrice = computed(() => {
  return usePriceFormatter(cartData.value?.info?.items_total);
});

const couponDiscount = computed(() => {
  return usePriceFormatter(cartData.value.info.coupon_discount);
});

// Cart data is already loaded from the store, no need to fetch again
// The store handles cart data fetching when products are added/removed
</script>

<template>
  <div class="bg-white">
    <div class="mb-3 cursor-pointer flex justify-end">
      <i
        class="m-icon-cancel text-2.5 ml-auto"
        @click="mainStore.cartVisible = false"
      ></i>
    </div>
    <div v-if="cartStore.cartData?.products?.length">
      <div class="mb-2 p-3 border-b-2 border-secondary00"><BasketItems /></div>
      <!--
      <div class="mb-2 p-3 border-b-2 border-secondary00">
        <CheckoutCoupon />
      </div>
      -->
      <div class="mb-2 p-3">
        <div class="grid grid-cols-2 text-sm">
          <div class="font-bold text-base mb-1">{{ t("products_total") }}</div>
          <div class="text-right font-bold text-base mb-1">
            {{ itemsPrice }}
          </div>
          <template
            v-if="
              cartData.info.coupon_discount && cartData.info.coupon_discount < 0
            "
          >
            <div class="mb-1">{{ t("discount") }}</div>
            <div class="text-right mb-1">{{ couponDiscount }}</div>
          </template>
          <div class="font-bold text-base mb-1">{{ t("shipping") }}</div>
          <div class="mb-1"></div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'personal')
                ?.name
            "
            class="mb-1"
          >
            {{
              shippingMethodsRef?.find((item: any) => item.id === "personal")
                ?.name
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'personal')
                ?.name
            "
            class="text-right mb-1"
          >
            {{ t("checkout.shipping_free") }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'gls')?.name
            "
            class="mb-1"
          >
            {{
              shippingMethodsRef?.find((item: any) => item.id === "gls")?.name
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'gls')?.name
            "
            class="text-right mb-1"
          >
            {{
              usePriceFormatter(
                parseInt(cartData?.info?.all_shipping_fees?.gls || "0"),
              )
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'gls_point')
                ?.name
            "
            class="mb-1"
          >
            {{
              shippingMethodsRef?.find((item: any) => item.id === "gls_point")
                ?.name
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'gls_point')
                ?.name
            "
            class="text-right mb-1"
          >
            {{
              usePriceFormatter(
                parseInt(cartData?.info?.all_shipping_fees?.gls_point || "0"),
              )
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'foxpost')
                ?.name
            "
            class="mb-1"
          >
            {{
              shippingMethodsRef?.find((item: any) => item.id === "foxpost")
                ?.name
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'foxpost')
                ?.name
            "
            class="text-right mb-1"
          >
            {{
              usePriceFormatter(
                parseInt(cartData?.info?.all_shipping_fees?.foxpost || "0"),
              )
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'mpl')?.name
            "
            class="mb-1"
          >
            {{
              shippingMethodsRef?.find((item: any) => item.id === "mpl")?.name
            }}
          </div>
          <div
            v-if="
              shippingMethodsRef?.find((item: any) => item.id === 'mpl')?.name
            "
            class="text-right mb-1"
          >
            {{
              usePriceFormatter(
                parseInt(cartData?.info?.all_shipping_fees?.mpl || "0"),
              )
            }}
          </div>
        </div>
      </div>

      <NuxtLink to="/order" @click="mainStore.cartVisible = false">
        <BaseButton type="checkout" class="w-full py-2.5 md:py-2">{{
          t("checkout.proceed_to_checkout")
        }}</BaseButton>
      </NuxtLink>
    </div>
    <div v-if="cartStore.cartData?.products?.length === 0">
      {{ t("checkout.cart_empty") }}
    </div>
  </div>
</template>
